@import '../../theme/global';

snap-main-navigation {
  bottom: 0;
  height: auto;
  left: 0;
  position: fixed;
  width: 100%;
  z-index: 9998;
  @include box-sizing;
  @include set-font;

  &.tool-switcher-open {
    z-index: 10000;
  }

  &>div {
    width: 100%;
  }

  @media (min-width: map-get($breakpoints, 'md')) {
    display: flex;
    top: 56px;
    width: 92px;
  }

  @media (min-width: map-get($breakpoints, 'lg')) {
    width: 286px;
  }

  &.mobile {
    bottom: 0;
    position: absolute;
    width: 100%;
  }
}

.snap-main-navigation {
  display: none;
  height: 100%;

  @media (min-width: map-get($breakpoints, 'md')) {
    display: flex;
  }

  &.snap-main-navigation-toolswitcher {
    @media (min-width: map-get($breakpoints, 'md')) {
      margin-top: 40px;
    }
    @media (min-width: map-get($breakpoints, 'lg')) {
      margin-top: 0;
    }

    .snap-main-navigation-сorner-wrapper {
      @media (min-width: map-get($breakpoints, 'md')) {
        top: 40px;
      }
      @media (min-width: map-get($breakpoints, 'lg')) {
        top: 0;
      }
    }

    .snap-main-navigation-tool-switcher-container {
      @media (min-width: map-get($breakpoints, 'md')) {
        height: 40px;
        margin: 0;
        position: absolute;
        top: 0;
        width: 100vw;
      }

      @media (min-width: map-get($breakpoints, 'lg')) {
        display: none;
      }
    }

    .snap-tool-switcher-desktop {
      display: none;
      @media (min-width: map-get($breakpoints, 'lg')) {
        display: block;
      }
    }

    .snap-main-navigation-container-inner {
      @media (min-width: map-get($breakpoints, 'lg')) {
        padding-top: 24px;
      }
    }

    snap-tool-switcher {
      @media (min-width: map-get($breakpoints, 'md')) {
        margin: 0;
      }
      @media (min-width: map-get($breakpoints, 'lg')) {
        margin: 6px 0 36px;
      }
    }

    &.snap-main-navigation {
      &--mobile {
        .snap-main-navigation-tool-switcher-container {
          background: $product-mobile;
        }
      }

      &--connect {
        .snap-main-navigation-tool-switcher-container {
          background-color: $product-connect;
        }
      }

      &--drive {
        .snap-main-navigation-tool-switcher-container {
          background-color: $product-drive;

        }
      }

      &--insights {
        .snap-main-navigation-tool-switcher-container {
          background-color: $product-insights;
        }
      }

      &--manage {
        .snap-main-navigation-tool-switcher-container {
          background-color: $product-manage;
        }
      }

      &--raise {
        .snap-main-navigation-tool-switcher-container {
          background-color: $product-raise;
        }
      }

      &--sites {
        .snap-main-navigation-tool-switcher-container {
          background-color: $product-sites;
        }
      }

      &--spend {
        .snap-main-navigation-tool-switcher-container {
          background-color: $product-spend;
        }
      }

      &--sponsor {
        .snap-main-navigation-tool-switcher-container {
          background-color: $product-sponsor;
        }
      }

      &--store {
        .snap-main-navigation-tool-switcher-container {
          background-color: $product-store;
        }
      }

      &--wallet {
        .snap-main-navigation-tool-switcher-container {
          background-color: $product-wallet;
        }
      }
    }
  }

  .snap-nav {
    flex: 1 1 0;
    margin-top: 0.25rem;
    padding-right: 1.5rem;

    @media (min-width: map-get($breakpoints, 'md')) {
      padding-right: 0.5rem;
    }

    @media (min-width: map-get($breakpoints, 'lg')) {
      padding-right: 1.5rem;
    }

    snap-main-navigation-option {
      font-weight: 500;

      .main-navigation-menu-item {
        border-radius: 0 0.625rem 0.625rem 0;
        color: rgba(255, 255, 255, .8);
        margin-bottom: 0.5rem;
        padding: 0.75rem 0 0.75rem 1.5rem;

        @media (min-width: map-get($breakpoints, 'md')) {
          flex-direction: column;
          font-size: 0.625rem;
          line-height: 1rem;
          padding: 0.25rem 0;
        }

        @media (min-width: map-get($breakpoints, 'lg')) {
          flex-direction: row;
          font-size: 0.875rem;
          padding: 0.75rem 0 0.75rem 1.5rem;
        }

        &.active {
          background-color: $base-light;
          box-shadow: 0 4px 2px -1px rgb(0, 0, 0, 0.1);
        }

        &:hover {
          background-color: rgba(255, 255, 255, 0.8);
        }

        snap-icon {
          color: rgba(255, 255, 255, .8);
          margin-right: 1.25rem;

          @media (min-width: map-get($breakpoints, 'md')) {
            margin-right: 0;
          }

          @media (min-width: map-get($breakpoints, 'lg')) {
            margin-right: 1.25rem;
          }
        }
      }
    }
  }

  &--mobile {
    .snap-main-navigation-container-inner {
      background: radial-gradient(1968.97% 429.96% at 38.29% 3.42%, #15339B 20.29%, #1269C1 81.08%);
    }

    snap-main-navigation-option {
      .main-navigation-menu-item {
        &:hover,
        &.active{
          color: $product-mobile;

          snap-icon {
            color: $product-mobile;
          }
        }
      }
    }

    .circle {
      border-color: #15339b;
    }
  }

  &--connect {
    .snap-main-navigation-container-inner {
      background-color: $product-connect;
    }

    snap-main-navigation-option {
      .main-navigation-menu-item {
        &:hover,
        &.active{
          color: $product-connect;

          snap-icon {
            color: $product-connect;
          }
        }
      }
    }

    .circle {
      border-color: $product-connect;
    }
  }

  &--drive {
    .snap-main-navigation-container-inner {
      background-color: $product-drive;
    }

    snap-main-navigation-option {
      .main-navigation-menu-item {
        &:hover,
        &.active{
          color: $product-drive;

          snap-icon {
            color: $product-drive;
          }
        }
      }
    }

    .circle {
      border-color: $product-drive;
    }
  }

  &--insights {
    .snap-main-navigation-container-inner {
      background-color: $product-insights;
    }

    snap-main-navigation-option {
      .main-navigation-menu-item {
        &:hover,
        &.active{
          color: $product-insights;

          snap-icon {
            color: $product-insights;
          }
        }
      }
    }

    .circle {
      border-color: $product-insights;
    }
  }

  &--manage {
    .snap-main-navigation-container-inner {
      background-color: $product-manage;
    }

    snap-main-navigation-option {
      .main-navigation-menu-item {
        &:hover,
        &.active{
          color: $product-manage;

          snap-icon {
            color: $product-manage;
          }
        }
      }
    }

    .circle {
      border-color: $product-manage;
    }
  }

  &--raise {
    .snap-main-navigation-container-inner {
      background-color: $product-raise;
    }

    snap-main-navigation-option {
      .main-navigation-menu-item {
        &:hover,
        &.active{
          color: $product-raise;

          snap-icon {
            color: $product-raise;
          }
        }
      }
    }

    .circle {
      border-color: $product-raise;
    }
  }

  &--sites {
    .snap-main-navigation-container-inner {
      background-color: $product-sites;
    }

    snap-main-navigation-option {
      .main-navigation-menu-item {
        &:hover,
        &.active{
          color: $product-sites;

          snap-icon {
            color: $product-sites;
          }
        }
      }
    }

    .circle {
      border-color: $product-sites;
    }
  }

  &--spend {
    .snap-main-navigation-container-inner {
      background-color: $product-spend;
    }

    snap-main-navigation-option {
      .main-navigation-menu-item {
        &:hover,
        &.active{
          color: $product-spend;

          snap-icon {
            color: $product-spend;
          }
        }
      }
    }

    .circle {
      border-color: $product-spend;
    }
  }

  &--sponsor {
    .snap-main-navigation-container-inner {
      background-color: $product-sponsor;
    }

    snap-main-navigation-option {
      .main-navigation-menu-item {
        &:hover,
        &.active{
          color: $product-sponsor;

          snap-icon {
            color: $product-sponsor;
          }
        }
      }
    }

    .circle {
      border-color: $product-sponsor;
    }
  }

  &--store {
    .snap-main-navigation-container-inner {
      background-color: $product-store;
    }

    snap-main-navigation-option {
      .main-navigation-menu-item {
        &:hover,
        &.active{
          color: $product-store;

          snap-icon {
            color: $product-store;
          }
        }
      }
    }

    .circle {
      border-color: $product-store;
    }
  }

  &--wallet {
    .snap-main-navigation-container-inner {
      background-color: $product-wallet;
    }

    snap-main-navigation-option {
      .main-navigation-menu-item {
        &:hover,
        &.active{
          color: $product-wallet;

          snap-icon {
            color: $product-wallet;
          }
        }
      }
    }

    .circle {
      border-color: $product-wallet;
    }
  }

  &-container-outer {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &-container-inner {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;
    padding-bottom: 1rem;
    padding-top: 1.25rem;
  }

  .snap-nav-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
}

.snap-main-navigation-mobile {
  box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.05);
  display: block;
  padding: 4px 8px 0;

  @media (min-width: map-get($breakpoints, 'md')) {
    display: none;
  }

  &.snap-main-navigation {
    &--mobile {
      background: radial-gradient(66.41% 1314.55% at 0% 0%, #15339B 49.94%, #1269C1 85.67%);

      .snap-main-navigation-tool-switcher-container {
        background: $product-mobile;
      }
    }

    &--connect {
      background-color: $product-connect;

      .snap-main-navigation-tool-switcher-container {
        background-color: $product-connect;
      }
    }

    &--drive {
      background-color: $product-drive;

      .snap-main-navigation-tool-switcher-container {
        background-color: $product-drive;
      }
    }

    &--insights {
      background-color: $product-insights;

      .snap-main-navigation-tool-switcher-container {
        background-color: $product-insights;
      }
    }

    &--manage {
      background-color: $product-manage;

      .snap-main-navigation-tool-switcher-container {
        background-color: $product-manage;
      }
    }

    &--raise {
      background-color: $product-raise;

      .snap-main-navigation-tool-switcher-container {
        background-color: $product-raise;
      }
    }

    &--sites {
      background-color: $product-sites;

      .snap-main-navigation-tool-switcher-container {
        background-color: $product-sites;
      }
    }

    &--spend {
      background-color: $product-spend;

      .snap-main-navigation-tool-switcher-container {
        background-color: $product-spend;
      }
    }

    &--sponsor {
      background-color: $product-sponsor;

      .snap-main-navigation-tool-switcher-container {
        background-color: $product-sponsor;
      }
    }

    &--store {
      background-color: $product-store;

      .snap-main-navigation-tool-switcher-container {
        background-color: $product-store;
      }
    }

    &--wallet {
      background-color: $product-wallet;

      .snap-main-navigation-tool-switcher-container {
        background-color: $product-wallet;
      }
    }
  }

  .snap-nav-mobile {
    display: flex;
  }

  .snap-main-navigation-tool-switcher-container {
    height: 40px;
    left: 0;
    position: fixed;
    top: 48px;
    width: 100vw;
    z-index: 1000;
  }

  snap-main-navigation-option {
    flex: 1 1 auto;

    .main-navigation-menu-item {
      align-items: center;
      border-radius: 0.625rem 0.625rem 0 0;
      color: rgba(255, 255, 255, 0.8);
      flex-direction: column;
      font-size: 0.625rem;
      font-weight: 500;
      line-height: 0.875rem;
      margin: 0.35rem 2px;

      &:hover {
        color: $base-light;

        snap-icon {
          color: $base-light;
        }
      }

      &.active {
        color: $base-light;

        .rounded-line {
          background-color: rgba(255, 255, 255, 0.8);
          border-radius: 99px;
          height: 3px;
          margin-top: 3px;
          width: 90%;
        }

        snap-icon {
          color: rgba(255, 255, 255, 0.8);
        }
      }

      snap-icon {
        color: rgba(255, 255, 255, 0.8);
        margin-bottom: 0.125rem;
        margin-right: 0;
      }
    }
  }
}

.snap-main-navigation-modal {
  background-color: $base-light;
  height: 100%;
  left: 0;
  outline: 0;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;

  &-fullscreen {
    height: 100%;
    margin: 0;
    max-width: none;
    width: 100vw;
  }

  .main-navigation-menu-item.active {
    background-color: $base-light;
  }

  &.snap-main-navigation {
    &--mobile {
      .snap-main-navigation-modal-fullscreen {
        background: radial-gradient(1968.97% 429.96% at 38.29% 3.42%, #15339B 20.29%, #1269C1 81.08%);
      }
    }

    &--connect {
      .snap-main-navigation-modal-fullscreen {
        background-color: $product-connect;
      }
    }

    &--drive {
      .snap-main-navigation-modal-fullscreen {
        background-color: $product-drive;
      }
    }

    &--insights {
      .snap-main-navigation-modal-fullscreen {
        background-color: $product-insights;
      }
    }

    &--manage {
      .snap-main-navigation-modal-fullscreen {
        background-color: $product-manage;
      }
    }

    &--raise {
      .snap-main-navigation-modal-fullscreen {
        background-color: $product-raise;
      }
    }

    &--sites {
      .snap-main-navigation-modal-fullscreen {
        background-color: $product-sites;
      }
    }

    &--spend {
      .snap-main-navigation-modal-fullscreen {
        background-color: $product-spend;
      }
    }

    &--sponsor {
      .snap-main-navigation-modal-fullscreen {
        background-color: $product-sponsor;
      }
    }

    &--store {
      .snap-main-navigation-modal-fullscreen {
        background-color: $product-store;
      }
    }

    &--wallet {
      .snap-main-navigation-modal-fullscreen {
        background-color: $product-wallet;
      }
    }

  }

  .modal-header {
    align-items: center;
    color: $base-light;
    display: flex;
    font-size: 1rem;
    font-weight: 600;
    justify-content: space-between;
    line-height: 1.5rem;
    padding: 1.5rem;

    snap-icon {
      color: $base-light;
      cursor: pointer;
    }
  }

  snap-main-navigation-option {
    font-weight: 500;

    .main-navigation-menu-item {
      color: rgba(255, 255, 255, 0.8);
      padding: 1rem 0.5rem 1rem 1.5rem;

      &:hover {
        background-color: rgba(255, 255, 255, 0.8);
      }

      snap-icon {
        color: rgba(255, 255, 255, 0.8);
        margin-right: 1rem;
      }
    }
  }
}

.snap-main-navigation-сorner-wrapper {
  height: 25px;
  overflow: hidden;
  position: absolute;
  right: -25px;
  top: 0;
  width: 25px;
}

.snap-main-navigation-сorner {
  background-color: transparent;
  height: 25px;
  overflow: hidden;
  position: relative;
  width: 25px;
}

.circle {
  border: 42px solid transparent;
  border-radius: 50%;
  height: 144px;
  left: -41.8px;
  position: absolute;
  top: -42.6px;
  width: 145px;
}

snap-tool-switcher {
  @media (min-width: map-get($breakpoints, 'lg')) {
    position: static;
  }
}



